import CrudRepository from './CrudRepository'
import Repository from './Repository'
export default class HotLineRepository extends CrudRepository {
  constructor () {
    super('core/api/hotLineLoss/')
  }

  async activate (item) {
    const data = await Repository.post(`${this.resource}activate`, item)
    return data
  }

  async deactivate (item) {
    const data = await Repository.post(`${this.resource}deactivate`, item)
    return data
  }
}
